import React from 'react'
import Router from 'Router'
// import LogRocket from 'logrocket'
import { GlobalStore } from './store/GlobalContext'

// LogRocket.init('zod43d/taskly')

export default () => {
  return (
    <div id="app" className="text-gray-700 bg-gray-50">
      <GlobalStore>
        <Router />
      </GlobalStore>
    </div>
  )
}
